import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim() });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Une erreur est survenue. Réessayez dans un instant.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={compact ? "" : "max-w-xl mx-auto"}>
      <div className="flex border border-jm-brass/30 focus-within:border-jm-amber transition-colors duration-300">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Votre adresse email"
          data-testid="newsletter-email-input"
          className="flex-1 min-w-0 bg-transparent px-4 py-3.5 text-sm text-jm-bone placeholder:text-jm-mute focus:outline-none"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-button"
          className="shrink-0 inline-flex items-center gap-2 bg-jm-amber text-jm-ink px-5 sm:px-7 text-sm font-medium tracking-wide hover:bg-jm-gold transition-colors duration-300 disabled:opacity-60"
        >
          {loading ? "Envoi…" : "S'inscrire"}
          <ArrowRight size={15} strokeWidth={2} />
        </button>
      </div>
      {!compact && (
        <p className="mt-4 text-xs text-jm-mute text-center">
          Actualités, sorties et concerts — un envoi par mois, jamais plus. Désinscription en un clic.
        </p>
      )}
    </form>
  );
}
